export default __webpack_public_path__ + "static/media/subLogo.d730c35c.svg";